export default __webpack_public_path__ + "static/media/our goal.36cbd22c.jpg";